import { DateFormatConstants, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { ITransitProgramRequirementStatus } from '../interfaces';

export class CertificationCourseStatus implements ITransitProgramRequirementStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  courseIdentifier: number;

  @autoserialize
  courseName: string;

  @autoserialize
  courseDescription: string;

  @autoserialize
  status: string;

  @autoserializeAs(Date)
  dueDate: Date;

  @autoserializeAs(Date)
  lastUpdatedDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: CertificationCourseStatus, json: any): void {
    if (!isNullOrUndefined(instance.dueDate)) {
      json.dueDate = DateUtil.serializeLocalDate(instance.dueDate);
    }

    if (!isNullOrUndefined(instance.lastUpdatedDate)) {
      json.lastUpdatedDate = DateUtil.serializeDate(instance.lastUpdatedDate);
    }
  }

  static OnDeserialized(instance: CertificationCourseStatus, json: any): void {
    if (!isNullOrUndefined(json['lastUpdatedDate'])) {
      instance.lastUpdatedDate = DateUtil.deserializeDate(json['lastUpdatedDate']);
    }

    if (!isNullOrUndefined(json['dueDate'])) {
      instance.dueDate = DateUtil.deserializeLocalDate(json['dueDate']);
    }
  }
}
